// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3Plqt","rootCenter":"LoadMoreObserver_rootCenter__11N1F","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1Nb5h"};